module.exports = __webpack_public_path__ + "static/media/50gb.b0f793e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/50gb.png
// module id = 136
// module chunks = 0